import { VariantProps } from "class-variance-authority";
import { Settings2 } from "lucide-react";
import { forwardRef } from "react";

import { useIsModerator } from "@/features/participants/api/is-moderator";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { ActionButton, ActionButtonProps } from "../action-button";

type ToggleModerationProps = Omit<ActionButtonProps, "Icon" | "text"> &
  VariantProps<typeof ActionButton> & {
    variant?: "default" | "ghost" | "destructive";
    size?: "fixed" | "auto";
  };

export const ToggleModeration = forwardRef<
  HTMLButtonElement,
  ToggleModerationProps
>(({ variant = "default", size = "fixed", ...props }, ref) => {
  const isModerator = useIsModerator();

  const isModerationDrawerOpened = useVidyoStore(
    (state) => state.moderationDrawer.isOpen,
  );

  const openModerationDrawer = useVidyoStore(
    (state) => state.moderationDrawer.open,
  );

  const handleOpenModerationDrawer = () => {
    openModerationDrawer();
  };

  const closeModerationDrawer = useVidyoStore(
    (state) => state.moderationDrawer.close,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isModerationDrawerOpened) {
      closeModerationDrawer();
    } else {
      handleOpenModerationDrawer();
    }

    // Call the original onClick handler if it exists,
    // this closes the dropdown menu
    props.onClick?.(event);
  };

  if (!isModerator) {
    return null;
  }

  return (
    <ActionButton
      {...props}
      ref={ref}
      variant={variant}
      size={size}
      onClick={handleClick}
      Icon={Settings2}
      text="Moderation"
      isActive={isModerationDrawerOpened}
    />
  );
});

ToggleModeration.displayName = "ToggleModeration";
